export function changePageTitle(title) {
  const titleElement = document.querySelector("title");
  if (titleElement) {
    titleElement.innerText = title;
  }
}
